import { ThemeOptions } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    animations: {
      spin: string;
    };
  }
  interface ThemeOptions {
    animations?: {
      spin?: string;
    };
  }
}

export const generateAnimationThemeOptions = (): ThemeOptions => ({
  animations: {
    spin: 'spin 1s linear infinite',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@keyframes spin': {
          '0%': {
            transform: 'rotate(0deg)',
          },
          '100%': {
            transform: 'rotate(360deg)',
          },
        },
      },
    },
  },
});
